export default {
  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        const sell = document.getElementById('sell-book')
        if (sell) sell.scrollTop = sell.scrollHeight
      })
    },
  }
}